import { CreateOfferDto } from '@interfaces/offers.interface';

import api from './';

export const { useInsertOfferMutation } = api.injectEndpoints({
  endpoints: (builder) => ({
    insertOffer: builder.mutation<void, CreateOfferDto>({
      query: (body) => ({
        url: '/offers',
        method: 'POST',
        body,
      }),
    }),
  }),
});
